
import { Base } from '../base-component';

import './contact-tile2-country-indiv-stack.component.scss';

export class ContactTile2CountryIndivStack extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){}

	bindEvents() {}

}


// WEBPACK FOOTER //
// ./components/contact-tile2-country-indiv-stack/contact-tile2-country-indiv-stack.component.ts